// Import statements
import React from 'react';
import Logo from '../images/vanani_logo.svg';

// Component definition
const Footer = () => {
  return (
    <div className='footer-wrapper'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4'>
            <div className='first_logo_text'>
              <img src={Logo} alt="Vanani Assosiated" />
              <p>At Vanani & Associates, we provide comprehensive financial and advisory services tailored to
                businesses of all sizes. Our team of experienced experts offers deep industry knowledge,
                ensuring personalized and ethical service. We are dedicated to driving growth and success
                for our clients through innovative solutions and unwavering commitment.</p>
            </div>
          </div>
          <div className='col-md-3'>
            <div className='link_list'>
              <h5>Important Links</h5>
              <ul>
                <li><a href='#'>Accounting</a></li>
                <li><a href='#'>Taxation</a></li>
                <li><a href='#'>Management Consultancy</a></li>
                <li><a href='#'>Knowledge Process Outsourcing</a></li>
                <li><a href='#'>Tax Litigation</a></li>
                <li><a href='#'>Corporate Complaince</a></li>
                <li><a href='#'>Audit</a></li>
                <li><a href='#'>CFO Services</a></li>
              </ul>
            </div>
          </div>

          <div className='col-md-2'>
            <div className='link_list'>
              <h5>Quick Links</h5>
              <ul>
                <li><a href='#'>Home</a></li>
                <li><a href='#'>About Us</a></li>
                <li><a href='#'>Services</a></li>
                <li><a href='#'>Industries</a></li>
                <li><a href='#'>Careers</a></li>
                <li><a href='#'>Knowledge Bank</a></li>
                <li><a href='#'>Blog</a></li>
                <li><a href='#'>Query</a></li>
                <li><a href='#'>Contact Us</a></li>
              </ul>
            </div>
          </div>

          <div className='col-md-3'>
            <div className='link_list'>
              <h5>Corporate Profile</h5>
              <div className='ft_img_wrap'>
                <img src='/images/footer_books.jpg'></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Export the component
export default Footer;
